import type { State } from "../../State";
import type { PdfChapterConfig } from "../PdfExportConfig";
import type { TechnicalReportId } from "./catalog";
import { actorReport, cablePullReport, consumerReport, sceneReport } from "./connections";
import { cabinetPartsReport, priceReport, terminalReport } from "./equipment";
import { statisticsReport } from "./statistics";
import type { TechnicalReport } from "./types";

/** Dispatches only native-model collectors; no old PDF schema or renderer is loaded. */
export function collectTechnicalReport(app: State, id: TechnicalReportId, config: PdfChapterConfig): TechnicalReport {
  switch (id) {
    case "actorList": return actorReport(app, config.actorShowImage ?? true);
    case "consumerConnections": return consumerReport(app, config.consumerGroupByRoom ?? true);
    // case "cableRouting": return cableReport(app, false);
    // case "cableWires": return cableReport(app, true);
    case "cablePull": return cablePullReport(app, config.cablePullCounts ?? true, config.cablePullPagePerRoom ?? false);
    case "scenes": return sceneReport(app, false);
    case "multiplexers": return sceneReport(app, true);
    // case "deviceTemplates": return templateReport(app);
    case "productPrices": return priceReport(app, config.pricesPerCabinet ?? false);
    case "cabinetParts": return cabinetPartsReport(app);
    case "terminals": return terminalReport(app, config.terminalShowUnusedWires ?? false, config.terminalSpacing ?? "normal");
    case "projectStatistics": return statisticsReport(app);
  }
}
